export default {
  "nav.home": "Accueil",
  "nav.spreadsheet": "Feuille de calcul",
  "nav.articles": "Guides",
  "nav.categories": "Catégories",
  "nav.shoppingGuide": "Guide d'achat",

  "hero.seoTitle": "usfans Spreadsheet — Trouvez des produits et économisez | usfanssheet.today",
  "hero.eyebrow": "LA RESSOURCE USFANS SPREADSHEET",
  "hero.title": "usfans Spreadsheet — Trouvez des produits, comparez les options et achetez malin",
  "hero.subtitle": "Explorez des trouvailles organisées de la feuille usfans, des guides d'achat et des astuces d'économie pratiques, au même endroit.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "acheter maintenant",
  "hero.trust": "Trouvailles produits • Astuces d'économie • Guides par catégorie • Conseils d'achat",

  "value.title": "Tout ce qu'il vous faut pour acheter malin, au même endroit",
  "value.subtitle": "Notre ressource de feuille usfans vous aide à parcourir les produits plus vite, à comprendre les catégories et à mieux décider avant d'acheter.",
  "value.card1.title": "Feuille usfans",
  "value.card1.desc": "Trouvez des découvertes de produits organisées et des infos utiles dans toutes les catégories.",
  "value.card2.title": "Astuces d'économie",
  "value.card2.desc": "Apprenez des façons pratiques de comparer les options et d'optimiser votre budget.",
  "value.card3.title": "Guides par catégorie",
  "value.card3.desc": "Comprenez chaussures, sweats, t-shirts, vestes, sacs et plus avant d'acheter.",
  "value.card4.title": "Conseils d'achat",
  "value.card4.desc": "Suivez un guide simple, étape par étape, pour choisir vos produits en toute confiance.",
  "value.card5.title": "Nouvelles trouvailles",
  "value.card5.desc": "Restez à jour avec de nouvelles idées de produits et des sélections tendance.",
  "value.card6.title": "Adapté aux débutants",
  "value.card6.desc": "Des explications faciles à suivre, pensées pour les nouveaux utilisateurs de la feuille.",

  "spreadsheet.title": "Parcourez de meilleurs produits avec la feuille usfans",
  "spreadsheet.copy": "Chercher parmi des milliers de produits peut prendre du temps. Notre ressource de feuille usfans organise des trouvailles utiles en catégories faciles à parcourir, pour que vous recherchiez plus vite et décidiez mieux avant d'acheter.",
  "spreadsheet.cta": "Parcourir la feuille usfans",

  "how.title": "Comment ça marche",
  "how.subtitle": "Un chemin simple, de la découverte à l'achat serein.",
  "how.step1": "Choisissez une catégorie",
  "how.step2": "Explorez les trouvailles",
  "how.step3": "Vérifiez les détails du produit",
  "how.step4": "Comparez vos options",
  "how.step5": "Appliquez les astuces d'économie",
  "how.step6": "Continuez vers le site principal",

  "popular.title": "Recherches populaires",
  "popular.subtitle": "Les sujets les plus recherchés autour de la feuille usfans.",
  "popular.1": "usfans spreadsheet",
  "popular.2": "trouvailles usfans spreadsheet",
  "popular.3": "conseils d'achat usfans",
  "popular.4": "économiser avec usfans",
  "popular.5": "catégories usfans",
  "popular.6": "guide usfans",
  "popular.7": "meilleures trouvailles usfans",
  "popular.8": "coupon usfans",
  "popular.9": "code promo usfans",

  "categories.title": "Parcourir les catégories",
  "categories.subtitle": "Accédez directement aux produits qui vous intéressent sur le site principal.",
  "categories.dropdownLabel": "Choisissez une catégorie",

  "safety.title": "Renseignez-vous avant d'acheter",
  "safety.copy": "Une bonne feuille doit vous aider à vous renseigner, pas vous pousser à acheter. Comparez les produits, vérifiez les détails et comprenez vos options avant de décider.",
  "safety.cta": "Parcourir les catégories",

  "articles.title": "Guides de la feuille usfans",
  "articles.subtitle": "Des articles originaux et détaillés pour acheter et économiser plus malin.",

  "final.title": "Prêt à explorer la feuille usfans ?",
  "final.copy": "Commencez par nos guides, comparez vos options et continuez vers le site principal quand vous êtes prêt.",
  "final.cta": "Explorer la feuille usfans",

  "footer.tagline": "Une ressource indépendante de trouvailles, guides et conseils d'achat de la feuille usfans.",
  "footer.disclaimer": "usfanssheet.today est une ressource informative indépendante. Vérifiez toujours les liens de destination et les offres actuelles sur le site principal avant d'acheter.",
  "footer.mainSite": "Site principal",
  "footer.allRights": "Tous droits réservés.",

  "article.backHome": "Retour à l'accueil",
  "article.related": "Articles liés",
  "article.updated": "Mis à jour",

  "notFound.title": "Page non trouvée",
  "notFound.subtitle": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "notFound.backHome": "Retour à l'accueil",

  "categories.shoes": "Chaussures",
  "categories.hoodies": "Sweats / Pulls",
  "categories.tshirts": "T-shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons / Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements",
  "categories.jersey": "Maillot",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",
};